import { ROUTE_NAMES, USER_ACTIONS, USER_SUBJECTS } from '@/utils/const.js';
const MeasurementUnits = () => import('./pages');

const moduleRoute = {
  path: 'master-data/measurement-units',
  name: 'MeasurementUnits',
  component: MeasurementUnits,
  meta: {
    allowAnonymous: false,
    ability: {
      subject: USER_SUBJECTS.COMPANY_SETTINGS,
      action: USER_ACTIONS.READ,
    },
    isNextAppPage: true,
  },
};

export default (router) => {
  router.addRoute(ROUTE_NAMES.BASE_LAYOUT, moduleRoute);
};
